import {dateTime, duration} from "services/date";
import {DataImport} from "types/DataImport";

/**
 * Transform the given Data Import by deserializing object properties
 *
 * @internal
 * @param dataImport
 */
export default function deserializeDataImport(dataImport: any): DataImport {
  dataImport.started_at = dateTime(dataImport.started_at)
  dataImport.ended_at = dateTime(dataImport.ended_at)
  dataImport.duration = duration(dataImport.duration)
  dataImport.created_at = dateTime(dataImport.created_at)
  dataImport.updated_at = dateTime(dataImport.updated_at)

  return dataImport;
}